import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { ROUTES } from "../routes/routes";
import { GiHamburgerMenu } from "react-icons/gi";
import { useNavigate } from "react-router-dom";

export const Hamburgernav = () => {
    const [searchQuery, setSearchQuery] = useState("");
    const navigate = useNavigate();

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        if (searchQuery.trim()) {
            navigate(`/search/${encodeURIComponent(searchQuery.trim())}`);
        }
    };

    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div className="burger">
            <h4 className="nav-title">
                <NavLink to={ROUTES.home.path}>PGM</NavLink>
            </h4>
            <button className="burger-button" onClick={toggleMenu}>
                <GiHamburgerMenu />
            </button>
            <div className={`burger-menu ${isOpen ? "open" : ""}`}>
                <ul>
                    <li className="nav-item">
                        <NavLink to={ROUTES.home.path}>Home</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={ROUTES.project.path}>Portfolio</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={ROUTES.blog.path}>Blog</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={ROUTES.opleiding.path}>Opleiding</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={ROUTES.services.path}>Services</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={ROUTES.programma.path}>Programma</NavLink>
                    </li>
                    <li className="nav-item">
                        <NavLink to={ROUTES.team.path}>Onze team</NavLink>
                    </li>
                    <li>
                        <form onSubmit={handleSearchSubmit}>
                            <input
                                type="text"
                                placeholder="Search.."
                                className="search-nav"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </form>
                    </li>
                </ul>
            </div>
        </div>
    );
};
